package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `POST /api/v1/account/email-verifications`: emails the signed-in user a new verification link. Answers 202 when
 * sent and 204 when the email is verified already.
 */
class WMResendEmailVerificationRequestBuilder:
    FSAuthenticatedRequestBuilder<WMResendEmailVerificationRequestBuilder, Nothing>() {

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "account", "email-verifications")
        return super.build()
    }

    override fun self(): WMResendEmailVerificationRequestBuilder = this
}
